import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { OperationentityCollectionCatagoryMappingEditSchema } from '../OperationentityCollectionCatagorySchema';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';

const screenCode = 'OPERATIONCOLLECTIONCATEGORYMAPPING';

export function OperationentityCollectionCatagoryMappingAddEdit(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Add Collection Category to Product");
    const [buttonText, setButtonText] = useState("Add");
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [product, setProduct] = useState();
    const [collectionCatagory, setCollectionCatagory] = useState();
    const [operationentityCollectionCatagoryMapping, setOperationentityCollectionCatagoryMapping] = useState({
        groupID: '0',
        operationEntityID: '0',
        productID: '0',
        collectionCategoryMasterID: '0',
        isActive: true
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "completed successfuly."
    });

    const schema = Joi.object(OperationentityCollectionCatagoryMappingEditSchema).options({ allowUnknown: true });

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
            )
    }, [operationentityCollectionCatagoryMapping.groupID]);

    useEffect(() => {
        trackPromise(
            getProductsForDropDown()
        )
    }, [operationentityCollectionCatagoryMapping.operationEntityID]);

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropdown()
            )
    }, [operationentityCollectionCatagoryMapping.productID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITOPERATIONCOLLECTIONCATEGORYMAPPING');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }
        
        if (data && edit) {
            setTitle("Edit Collection Category to Product");
            fillOperationEntityProductEditdata();
            setButtonText("Update");
        } else {
            setTitle("Add Collection Category to Product");
        }

        trackPromise(
            getGroupsForDropdown()
        )
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await services.getAllOperationEntitiesForDropDown(operationentityCollectionCatagoryMapping.groupID);
        setOperationEntity(opEntities);
    }

    async function getCollectionCategoryForDropdown() {
        const collectionCatagories = await services.GetUnassignedCollectionCategoryByOperationentity(operationentityCollectionCatagoryMapping);
        setCollectionCatagory(collectionCatagories);
    }

    async function getProductsForDropDown() {
        var products = await services.getAvialableProducts(operationentityCollectionCatagoryMapping.operationEntityID);
        setProduct(products);
    }

    async function fillOperationEntityProductEditdata() {
        const selectedOperationEntity = await services.getGroupByCollectionCatagoryID(data.collectionCategoryID.toString());

        if (data.isActive === true) {
            setButtonText("Deactivate");
        }
        else {
            setButtonText("Activate");
        }

        if (selectedOperationEntity) {
            setOperationentityCollectionCatagoryMapping({
                ...operationentityCollectionCatagoryMapping,
                groupID: selectedOperationEntity[0].groupID.toString(),
                operationEntityID: selectedOperationEntity[0].operationEntityID.toString(),
                productID: selectedOperationEntity[0].productID.toString(),
                collectionCategoryMasterID: data.collectionCategoryMasterID,
                isActive: data.isActive
            });
        }
    }

    function validateInputs(target){
        const error = { ...errors }
        const errorMessage = validateProperty(target, OperationentityCollectionCatagoryMappingEditSchema)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setErrors(error);
    }

    function handleGroupChange(target){
        validateInputs(target);

        setOperationentityCollectionCatagoryMapping({
            ...operationentityCollectionCatagoryMapping,
            groupID: target.value,
            operationEntityID: "0",
            productID: "0",
            collectionCategoryMasterID: "0"
        });
    }

    function handleOperationEntityChange(target){
        validateInputs(target);

        setOperationentityCollectionCatagoryMapping({
            ...operationentityCollectionCatagoryMapping,
            operationEntityID: target.value,
            productID: "0",
            collectionCategoryMasterID: "0"
        });
    }

    function handleProductChange(target){
        validateInputs(target);

        setOperationentityCollectionCatagoryMapping({
            ...operationentityCollectionCatagoryMapping,
            productID: target.value,
            collectionCategoryMasterID: "0"
        });
    }

    function handleCollectionCategoryMasterChange(target){
        validateInputs(target);

        setOperationentityCollectionCatagoryMapping({
            ...operationentityCollectionCatagoryMapping,
            collectionCategoryMasterID: target.value,
        });
    }

    function handleActiveChange(target) {
        validateInputs(target);
    
        setOperationentityCollectionCatagoryMapping({
            ...operationentityCollectionCatagoryMapping,
          isActive: target.checked,
        });
    }

    async function handleSave(e) {
        e.preventDefault();

        const errorMessages = validate(schema, operationentityCollectionCatagoryMapping);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        if (!edit) {
            var result = await services.AddOperationentityCollectionCatagory(operationentityCollectionCatagoryMapping);
            setMessageModel({ ...messageModel, hidden: false, type: result.statusCode, disciption: result.message });
            afterSuccessfulyChanged(result.statusCode);
        } else if (edit) {
            var result = await services.EditOperationentityCollectionCatagory(data.collectionCategoryID);
            setMessageModel({ ...messageModel, hidden: false, type: result.statusCode, disciption: result.message });
            afterSuccessfulyChanged(result.statusCode);
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/opcollectioncatagorymapping' })
            }, 1500);
        }
    }

    function clearState() {
        setOperationentityCollectionCatagoryMapping({
            ...operationentityCollectionCatagoryMapping,
            groupID: '0',
            operationEntityID: '0',
            productID: '0',
            collectionCategoryMasterID: '0',
            isActive: true
        });
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    path="/opcollectioncatagorymapping"
                                    buttonText="Back to listing"
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => trackPromise(handleSave(e))} disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={(edit && data) ? true : false}
                                            value={operationentityCollectionCatagoryMapping.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={(edit && data) ? true : false}
                                            value={operationentityCollectionCatagoryMapping.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="productID">Product *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="productID"
                                            id="productID"
                                            name="productID"
                                            disabled={(edit && data) ? true : false}
                                            value={operationentityCollectionCatagoryMapping.productID}
                                            onChange={(e) => handleProductChange(e.target)}>
                                            <MenuItem value="0">--Select Product--</MenuItem>
                                            {generateDropDownMenu(product)}
                                        </Select>
                                        {errors["productID"] && <FormHelperText error>{errors["productID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionCategoryMasterID">Collection category  *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionCategoryMasterID"
                                            id="collectionCategoryMasterID"
                                            name="collectionCategoryMasterID"
                                            value={operationentityCollectionCatagoryMapping.collectionCategoryMasterID}
                                            onChange={(e) => handleCollectionCategoryMasterChange(e.target)}>
                                            <MenuItem value="0">--Select Collection Category--</MenuItem>
                                            {generateDropDownMenu(collectionCatagory)}
                                        </Select>
                                        {errors["collectionCategoryMasterID"] && <FormHelperText error>{errors["collectionCategoryMasterID"]}</FormHelperText>}
                                    </div>
                                </div>

                                {(edit && data) ? null :
                                    <div>
                                        <label>Active</label>
                                        <div className="form-group row">
                                            <div className="col-md ">
                                                <input
                                                    id="isActive"
                                                    switch="none"
                                                    className="mr-2"
                                                    type="checkbox"
                                                    name="isActive"
                                                    onChange={(e) => handleActiveChange(e.target)}
                                                    checked={operationentityCollectionCatagoryMapping.isActive}
                                                />
                                                <label htmlFor="isActive" data-on-label="Yes"
                                                    data-off-label="No"></label>
                                            </div>
                                        </div>
                                    </div>}

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, operationentityCollectionCatagoryMapping)}
                                        type="submit"
                                        className="btn btn-primary"
                                        value={buttonText}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}